import * as RadixTooltip from "@radix-ui/react-tooltip";
import type { FC, ReactNode } from "react";

import { cn } from "../utils";
import { MomentTooltip, type TooltipContentProps } from "./Tooltip";

export interface BasicTooltipProps {
	children: ReactNode;
	content: ReactNode;
	triggerProps?: RadixTooltip.TooltipTriggerProps;
	contentProps?: TooltipContentProps;
	withPortal?: boolean;
	withArrow?: boolean;
}
export const MomentBasicTooltip: FC<BasicTooltipProps> = ({
	children,
	content,
	triggerProps = {},
	contentProps = {},
	withPortal = true,
	withArrow = false,
}) => {
	const portalContent = content && (
		<MomentTooltip.Content side="bottom" {...contentProps}>
			{withArrow && (
				<RadixTooltip.Arrow
					className={cn(
						"z-10",
						contentProps.level === "secondary"
							? "fill-bg-primary"
							: "fill-bg-inverse-primary"
					)}
					width={15}
					height={8}
				/>
			)}
			{content}
		</MomentTooltip.Content>
	);
	return (
		<MomentTooltip.Provider>
			<MomentTooltip.Root>
				<MomentTooltip.Trigger asChild {...triggerProps}>
					{children}
				</MomentTooltip.Trigger>
				{withPortal ? (
					<MomentTooltip.Portal>{portalContent}</MomentTooltip.Portal>
				) : (
					portalContent
				)}
			</MomentTooltip.Root>
		</MomentTooltip.Provider>
	);
};
